/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { IXYAdjustHandle } from "../interfaces/model/geometry/XYAdjustHandle";
import { PageObjectType } from "../interfaces/model/Types";

/** Image crop shape render properties */
export interface IImageCropShapeRenderProps {
    /** The pageObject corresponding to image */
    pageObject: PageObjectType;
    /** Adjust handler. As of now, not using it. However, these will be required to adjust the cropping shape */
    adjustHandlers: IXYAdjustHandle[];
    /** The geometry path in terms of SVG Path */
    path: string;
    /** The depth of rendering hierarchy corresponding to image for which this corpping shape affects */
    depth: number;
}

/**
 * Image crop shape.
 * Provides SVG clip path component for image cropping purpose
 */
export class ImageCropShape extends WidgetBase<IImageCropShapeRenderProps> {
	/**
	 * Override WidgetBase#render to produce a virtual DOM tree.
	 * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
	 */
	protected render() {
		return (
			<clipPath id={`shape-${this.properties.depth}-${this.properties.key}-mask`}>
				<path d={`${this.properties.path}`} />
			</clipPath>
		);
	}
}

export default ImageCropShape;
